module.exports = __webpack_public_path__ + "static/media/comites-investigacion-mini.be3504f4.jpg";